import { Injectable } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, OperatorFunction, tap } from 'rxjs';
import { Pages } from '../../pages';
import { ModalService } from '../../../core/modal/modal.service';

@Injectable({
  providedIn: 'root',
})
export class RetailPlaceDetailsState {
  private retailPlaceScrollPosition = 0;
  private lastRetailPlaceId = 0;

  constructor(
    private router: Router,
    private modalService: ModalService,
  ) {
    this.resetScrollPosition();
  }

  getRetailPlaceScrollPosition(id: number): number {
    return this.lastRetailPlaceId === id ? this.retailPlaceScrollPosition : 0;
  }

  setRetailPlaceScrollPosition(position: number): void {
    if (!this.modalService.getModalVisibility()) this.retailPlaceScrollPosition = position;
  }

  setRetailPlaceId(id: number): void {
    this.lastRetailPlaceId = id;
  }

  private resetScrollPosition(): void {
    let currentUrl = '';
    this.router.events
      .pipe(
        tap((event) => {
          if (event instanceof NavigationStart) {
            currentUrl = this.router.url;
          }
        }),
        filter(event => (
          event instanceof NavigationEnd)
          && currentUrl.startsWith(`${Pages.Kkms}/retailPlace`)
          && !event.urlAfterRedirects.startsWith(`${Pages.Kkms}/`)) as OperatorFunction<Event, NavigationEnd>,
      )
      .subscribe(() => this.setRetailPlaceScrollPosition(0));
  }
}
